import { types as t, getRoot } from 'mobx-state-tree'
import { Challenge } from '../../../lib/constants'

export const ChallengesModel = t
  .model('ChallengesModel', {
    _selectedChallege: t.maybeNull(t.string),
    hoveredChallenge: t.maybeNull(t.string),
  })
  .views((self) => ({
    get selectedChallege() {
      return self._selectedChallege || (getRoot(self) as any).Circles.challenge
    },
  }))
  .actions((self) => ({
    setSelectedChallenge(challenge: Challenge) {
      self._selectedChallege = challenge
    },
    setHoveredChallenge(challenge: Challenge) {
      self.hoveredChallenge = challenge
    },
  }))
